import PropTypes from 'prop-types';

import { createContext, useState, useMemo } from 'react';
import { useNavigate } from 'react-router';
import { paths } from 'src/routes/paths';

const StepContext = createContext({
  handleNext: () => {},
  handleBack: () => {},
});

export const StepQrProvider = ({ children }) => {
  const [activeStep, setActiveStep] = useState('scanQR');
  const navigate = useNavigate();

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = (step) => {
    if (activeStep === 'scanQR') navigate(paths.home.root);
    setActiveStep(step);
  };

  const value = useMemo(
    () => ({
      setActiveStep,
      activeStep,
      handleNext,
      handleBack,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [activeStep]
  );

  return <StepContext.Provider value={value}>{children}</StepContext.Provider>;
};

StepQrProvider.propTypes = {
  children: PropTypes.node,
};

export default StepContext;
